import React, { useState } from 'react';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { cn } from '../utils/cn';

const Selector = (props) => {
  const { placeholder = 'Выберите значение...', className = '', onChange, defaultValue = '', prefix, showReset = true, options = [] } = props;

  const [selectedValue, setSelectedValue] = useState(defaultValue);

  const onHandleChange = (e) => {
    const value = e.target.value;
    onChange(value);
    setSelectedValue(value);
  };

  const handleReset = () => {
    setSelectedValue('');
    onChange?.('');
  };

  return (
    <div className={`flex items-center bg-white border border-gray-300 rounded-lg overflow-hidden shadow-sm ${className}`}>
      {prefix && <div className="flex pl-2">{prefix}</div>}

      <select
        value={selectedValue}
        onChange={onHandleChange}
        className={cn(
          `flex-1 py-2 text-sm text-gray-800 focus:outline-none bg-transparent appearance-none`,
          !selectedValue && 'text-gray-400',
          !prefix && 'px-3'
        )}>
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((opt) => (
          <option key={opt.value ?? opt.id} value={opt.value ?? opt.id}>
            {opt.label ?? opt.name}
          </option>
        ))}
      </select>

      {showReset && selectedValue && (
        <CloseOutlinedIcon fontSize="inherit" className="cursor-pointer flex w-4 h-4 mr-2 text-gray-500 hover:text-gray-700" onClick={handleReset} />
      )}
    </div>
  );
};

export default Selector;
